import { render, staticRenderFns } from "./LearnerInfo.vue?vue&type=template&id=753ffd78&scoped=true&"
import script from "./LearnerInfo.vue?vue&type=script&lang=ts&"
export * from "./LearnerInfo.vue?vue&type=script&lang=ts&"
import style0 from "./LearnerInfo.vue?vue&type=style&index=0&id=753ffd78&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "753ffd78",
  null
  
)

export default component.exports